import React, { useEffect } from "react";

export const hasTextValue = (value) =>
  typeof value === "string" && value.trim().length > 0;

export const getOnlineTextForLanguage = (
  prestashopOnline,
  site,
  textField,
  lang,
) => {
  const siteData = prestashopOnline?.sites?.[site];
  if (!siteData?.available) return "";

  const normalizedLang = String(lang || "").toLowerCase();
  const language = siteData.languages?.find(
    (item) => String(item?.isoCode || "").toLowerCase() === normalizedLang,
  );
  const row = siteData.texts?.[textField]?.find((item) => {
    if (
      item?.isoCode &&
      String(item.isoCode).toLowerCase() === normalizedLang
    ) {
      return true;
    }
    return (
      language &&
      String(item?.languageId) === String(language.languageId)
    );
  });

  return hasTextValue(row?.value) ? row.value : "";
};

function HtmlPreview({ value, emptyMessage }) {
  if (!hasTextValue(value)) {
    return <p className="ma0 f6 i">{emptyMessage}</p>;
  }

  return (
    <div
      className="modificaProdottiImportaTestoHtml"
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );
}

function ImportaTestoOnlineModal({
  open,
  sourceTitle,
  sourceHtml,
  dominoShortHtml,
  targetLabel,
  onUse,
  onClose,
  buttonClassesWhite,
}) {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 bottom-0 z-999 sfondoOverlayTema flex items-center justify-center pa3"
      onMouseDown={onClose}
    >
      <div
        className="modificaProdottiImportaTestoModal sfondoBiancoTema black-80 br3 shadow-5"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modificaProdottiImportaTestoTitolo"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="modificaProdottiImportaTestoHeader">
          <div>
            <h3 id="modificaProdottiImportaTestoTitolo" className="ma0">
              Importa testo
            </h3>
            <p className="mt1 mb0 f6">
              Scegli quale testo usare come {targetLabel.toLowerCase()}.
            </p>
          </div>
        </div>

        <div className="modificaProdottiImportaTestoColumns">
          <section className="modificaProdottiImportaTestoSource">
            <h4 className="mt0 mb2">{sourceTitle}</h4>
            <div className="modificaProdottiImportaTestoPreview">
              <HtmlPreview
                value={sourceHtml}
                emptyMessage="Testo online non presente nella lingua corrente."
              />
            </div>
            <button
              type="button"
              className={buttonClassesWhite}
              disabled={!hasTextValue(sourceHtml)}
              onClick={() => onUse(sourceHtml)}
            >
              Usa come {targetLabel.toLowerCase()}
            </button>
          </section>

          <section className="modificaProdottiImportaTestoDomino">
            <h4 className="mt0 mb2">Descrizione breve Domino</h4>
            <div className="modificaProdottiImportaTestoPreview">
              <HtmlPreview
                value={dominoShortHtml}
                emptyMessage="Descrizione breve Domino non presente."
              />
            </div>
            <button
              type="button"
              className={buttonClassesWhite}
              disabled={!hasTextValue(dominoShortHtml)}
              onClick={() => onUse(dominoShortHtml)}
            >
              Usa come {targetLabel.toLowerCase()}
            </button>
          </section>
        </div>

        <div className="modificaProdottiImportaTestoFooter">
          <button
            type="button"
            className={buttonClassesWhite}
            onClick={onClose}
          >
            Indietro
          </button>
        </div>
      </div>
    </div>
  );
}

export default ImportaTestoOnlineModal;
